import { createFileRoute } from '@tanstack/react-router';

import { SourcingTemplateCreatePage } from '@/areas/sourcing-scenarios/SourcingTemplates/SourcingTemplateCreatePage';
import { canManageSourcingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/sourcing/create')({
    staticData: { access: { permissions: canManageSourcingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SourcingTemplateCreatePage />;
}
